module.exports = __webpack_public_path__ + "img/baseinfotop.842ac319.png";